import * as z from 'zod';

/** Same tolerance as the legacy validator: fractions may be up to 0.01 away from 1.0, i.e. 1 percentage point. */
export const isCloseToHundred = (weights: Record<string, number>) => {
  const total = Object.values(weights).reduce((sum, value) => sum + value, 0);
  return Math.abs(total - 100) <= 1;
};

const weightSchema = z.coerce.number().min(0).max(100);

export const kpiConfigurationFormSchema = z
  .object({
    QnMatrixMinLevel: z.coerce.number(),
    QnMatrixMaxLevel: z.coerce.number(),
    NormalizedMaxScale: z.coerce
      .number()
      .min(1, { message: 'NORMALIZED_MAX_SCALE_MUST_BE_AT_LEAST_1' }),
    ReviewerGroupWeights: z.record(z.string(), weightSchema),
    CategoryWeights: z.record(z.string(), weightSchema),
  })
  .refine((data) => data.QnMatrixMinLevel < data.QnMatrixMaxLevel, {
    message: 'KPI_CONFIG_ERR_RANGE_INVALID',
    path: ['QnMatrixMaxLevel'],
  })
  .refine((data) => isCloseToHundred(data.ReviewerGroupWeights), {
    message: 'KPI_CONFIG_ERR_MUST_TOTAL_100',
    path: ['ReviewerGroupWeights'],
  })
  .refine((data) => isCloseToHundred(data.CategoryWeights), {
    message: 'KPI_CONFIG_ERR_MUST_TOTAL_100',
    path: ['CategoryWeights'],
  });

export type KpiConfigurationFormValues = z.infer<typeof kpiConfigurationFormSchema>;
